module.exports = __webpack_public_path__ + "img/bigStart.ac58c839.svg";